// src/components/DemoEntryPage.js
// Punto di ingresso pubblico alla demo — nessuna registrazione, nessuna email, nessuna
// password. Chi apre nexiora.it/demo riceve un accesso anonimo automatico e si ritrova
// dentro l'organizzazione demo, in sola consultazione (bloccata dalle regole Firestore,
// non solo dall'interfaccia).
import React, { useEffect, useState } from "react";
import { useAuth } from "../contexts/AuthContext";

export default function DemoEntryPage() {
  const { entraNellaDemo } = useAuth();
  const [errore, setErrore] = useState(null);

  useEffect(() => {
    entraNellaDemo().catch(err => {
      console.error("Errore ingresso demo:", err);
      setErrore("Non è stato possibile accedere alla demo in questo momento. Riprova tra qualche minuto.");
    });
  }, [entraNellaDemo]);

  return (
    <div style={{ minHeight:"100vh", display:"flex", alignItems:"center", justifyContent:"center", background:"#faf5ff", fontFamily:"'Inter',sans-serif" }}>
      <div style={{ textAlign:"center", maxWidth:360, padding:24 }}>
        {errore ? (
          <>
            <div style={{ fontSize:32, marginBottom:12 }}>⚠️</div>
            <div style={{ fontSize:14, color:"#991b1b", fontWeight:600 }}>{errore}</div>
          </>
        ) : (
          <>
            <div style={{ width:36, height:36, border:"3px solid #e9d5ff", borderTopColor:"#7c3aed", borderRadius:"50%", margin:"0 auto 16px", animation:"spin 0.8s linear infinite" }}/>
            <div style={{ fontSize:14, color:"#5b21b6", fontWeight:600 }}>Sto aprendo la demo di Nexiora...</div>
            <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
          </>
        )}
      </div>
    </div>
  );
}
